/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): index.umd.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert FROM './src/alert'
import Button FROM './src/button'
import Carousel FROM './src/carousel'
import Collapse FROM './src/collapse'
import Dropdown FROM './src/dropdown'
import Modal FROM './src/modal'
import Offcanvas FROM './src/offcanvas'
import Popover FROM './src/popover'
import ScrollSpy FROM './src/scrollspy'
import Tab FROM './src/tab'
import Toast FROM './src/toast'
import Tooltip FROM './src/tooltip'

export default {
  Alert,
  Button,
  Carousel,
  Collapse,
  Dropdown,
  Modal,
  Offcanvas,
  Popover,
  ScrollSpy,
  Tab,
  Toast,
  Tooltip
}
